(() => {
  const initialized = new WeakSet();
  const desktop = window.matchMedia('(min-width: 960px) and (hover: hover) and (pointer: fine)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const resets = new Set();
  function init(root) {
    root.querySelectorAll('[data-cascas-colour-preview]').forEach(group => {
      if (initialized.has(group)) return;
      const value = group.querySelector('.cascas-colour-value');
      if (!value) return;
      initialized.add(group);
      const original = value.textContent.trim();
      const current = document.createElement('span');
      current.className = 'cascas-colour-current';
      current.textContent = original;
      value.replaceChildren(current);
      let animations = [];
      let outgoing;
      let timer;
      let revision = 0;
      function show(name, immediate = false) {
        clearTimeout(timer);
        if (name === current.textContent && !immediate) return;
        const old = current.textContent;
        const token = ++revision;
        animations.forEach(animation => animation.cancel());
        animations = [];
        if (outgoing) outgoing.remove();
        current.textContent = name;
        if (immediate || reduced.matches || !current.animate || old === name) return;
        outgoing = document.createElement('span');
        outgoing.className = 'cascas-colour-outgoing';
        outgoing.setAttribute('aria-hidden', 'true');
        outgoing.textContent = old;
        value.append(outgoing);
        const ghost = outgoing;
        const options = {duration: 220, easing: 'cubic-bezier(0.22, 1, 0.36, 1)'};
        const leave = ghost.animate([{transform: 'translateY(0)', opacity: 1}, {transform: 'translateY(-100%)', opacity: 0}], options);
        const enter = current.animate([{transform: 'translateY(100%)', opacity: 0}, {transform: 'translateY(0)', opacity: 1}], options);
        animations = [leave, enter];
        enter.onfinish = () => {
          if (token !== revision) return;
          ghost.remove();
          outgoing = null;
          animations = [];
        };
      }
      function reset(immediate = false) { show(original, immediate); }
      function preview(anchor) {
        if (desktop.matches && anchor.dataset.cascasColourName) show(anchor.dataset.cascasColourName);
      }
      group.querySelectorAll('a[data-cascas-colour-name]').forEach(anchor => {
        anchor.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') preview(anchor);
        });
        anchor.addEventListener('focus', () => preview(anchor));
        anchor.addEventListener('click', () => reset(true));
      });
      group.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') timer = setTimeout(() => reset(), 80);
      });
      group.addEventListener('focusout', event => {
        if (!group.contains(event.relatedTarget)) reset();
      });
      resets.add(() => {
        if (!group.isConnected) return false;
        reset(true);
        return true;
      });
    });
  }
  function resetAll() { resets.forEach(reset => { if (!reset()) resets.delete(reset); }); }
  desktop.addEventListener('change', resetAll);
  reduced.addEventListener('change', resetAll);
  window.addEventListener('blur', resetAll);
  document.addEventListener('shopify:section:load', event => init(event.target));
  init(document);
})();
